import { render, staticRenderFns } from "./EditProjectIssue.vue?vue&type=template&id=29e1ae36&scoped=true&"
import script from "./EditProjectIssue.vue?vue&type=script&lang=js&"
export * from "./EditProjectIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1ae36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
